import setCurrentPage from "src/Utils/setCurrentPage";
import Image from "src/Components/Common/Image";
import store from "src/Reducers/store";

const previousPage = () => store.getState().appReducer.previousPage;

export const DATA_DS_DEMO_DNA2_7 = {
  title:
    "Introducing Business Analytics Vivian, who \nlacks technical expertise in coding. \nDespite facing a short one week \ndeadline, she needs to build eight \nscenarios of batch pipelines.",
  subtitle: "Data STREAMS demo",
  next: {
    label: "CONTINUE",
    onClick: () => {
      setCurrentPage(212);
    },
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(previousPage()),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "DNA2/DNA2_intro_04.jpg",
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "InfosysTopazLogo.png",
  rightSideComponent: (
    <div style={{ position: "absolute", bottom: "0", right: "0" }}>
      <div
        style={{
          position: "relative",
          width: "833px",
          height: "800px",
          overflow: "hidden",
        }}
      >
        <Image
          styleImage={{
            position: "absolute",
            bottom: "121px",
            right: "581px",
            zIndex: 1,
          }}
          imagePath="DNA2/DNA2_demo2_name.png"
        />
        <Image
          styleImage={{
            position: "absolute",
            width: "800px",
            height: "auto",
            bottom: "0px",
            right: "-79px",
          }}
          imagePath="characters/character_dna2_2.gif"
        />
      </div>
    </div>
  ),
};
